document.addEventListener('click', function (event) {
  const trigger = event.target.closest('[data-search-trigger]');
  if (!trigger) return;

  // Dawn / OS 2.0 header search summary
  const searchSummary = document.querySelector(
    'details-modal.header__search summary.header__icon--search'
  );

  if (searchSummary) {
    searchSummary.click();
    return;
  }

  // Fallback (very rare)
  window.location.href = window.Shopify.routes.root + 'search';
});
